<script lang="ts" setup>
import { useCopy } from "@/composables";

const props = withDefaults(
  defineProps<{
    text: string;
    size?: string | number;
    color?: string;
  }>(),
  {
    size: 16,
    color: "primary",
  },
);

const { copy } = useCopy();
</script>

<template>
  <span class="d-flex align-center col-gap-1 pointer" @click="copy(props.text)">
    <slot />
    <v-icon :color="props.color" :size="props.size" icon="mdi-content-copy" />
  </span>
</template>
